import React, { useContext } from 'react'

import type { RecipeGridContentBlock } from '@library/api-menu-experience'
import { RecipeGrid } from '@library/menu-page'
import type { RecipeUUID } from '@library/menu-service'

import { useSetBrowserCTAVisibility } from 'routes/Menu/domains/menu'

import { MenuBrandingContext } from '../menuBrandingContext'
import { useMenuExperienceRecipeDetails } from '../menuExperienceRecipeDetailContext'
import { useRecipeGridBasket } from './useRecipeGridBasket'
import { useRecipeGridCustomisationData } from './useRecipeGridCustomisationData'

type RecipeGridContentBlockWrapperProps = {
  contentBlock: RecipeGridContentBlock
  collectionId?: string
}

export const RecipeGridContentBlockWrapper = ({
  contentBlock,
  collectionId,
}: RecipeGridContentBlockWrapperProps) => {
  const { textColor } = useContext(MenuBrandingContext)
  const { openRecipeDetail } = useMenuExperienceRecipeDetails()
  const { setBrowserCTAVisible } = useSetBrowserCTAVisibility()
  const { getRecipeTileState, onAddClick, onRemoveClick } = useRecipeGridBasket(contentBlock.items)
  const { getRecipeCustomisationData, openRecipeCustomisations, closeRecipeCustomisations } =
    useRecipeGridCustomisationData({ collectionId })

  const onRecipeClick = (recipeId: RecipeUUID, recipePosition: number) => {
    const recipe = contentBlock.items.find((item) => item.id === recipeId)

    if (!recipe) {
      return
    }

    openRecipeDetail({
      recipeId,
      title: recipe.title,
      position: recipePosition.toString(),
      source: 'recipe_grid',
    })
  }

  return (
    <RecipeGrid
      contentBlock={contentBlock}
      recipeCountTextColor={textColor}
      getRecipeTileState={getRecipeTileState}
      getRecipeCustomisationData={getRecipeCustomisationData}
      onRecipeClick={onRecipeClick}
      onAddClick={onAddClick}
      onRemoveClick={onRemoveClick}
      onBlockedAddAttempt={setBrowserCTAVisible}
      onCustomiseOpen={openRecipeCustomisations}
      onCustomiseClose={closeRecipeCustomisations}
    />
  )
}
